function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.608 15.5V9.294c0-2.521-1.041-4.832-2.761-6.522C20.133 1.082 17.692-.002 15 0c-2.692-.002-5.133 1.083-6.846 2.772-1.72 1.69-2.762 4.001-2.762 6.522V11H5.39a1 1 0 001 1H8.5a1 1 0 001-1V8.928c0-1.477.653-2.783 1.669-3.713A5.649 5.649 0 0115 3.75a5.646 5.646 0 013.83 1.465c1.016.93 1.669 2.236 1.669 3.713V15.5H3.74c-.685 0-1.24.51-1.24 1.14v12.22c0 .63.555 1.14 1.24 1.14h22.52c.685 0 1.24-.51 1.24-1.14V16.64c0-.63-.555-1.14-1.24-1.14h-1.652z",
  fill: "currentColor"
})));